export default __webpack_public_path__ + "static/media/17.9fbf2477.png";